"use strict";
document.addEventListener("DOMContentLoaded", function() {
    var count = 10;
    var interval = setInterval(function() {
        console.log(count--);
        if (count === 0) clearInterval(interval);
    }, 1000);
});

//# sourceMappingURL=index.3ac19435.js.map
